export class BasicCells
{
    /**
     * @param {number} nb Nombre de cellules de base sur la période
     * @param {number} width Largeur de la cellule de base
     */
    constructor (public nb: number, public width: number)
    {
    }
}
